export default __webpack_public_path__ + "static/media/apple.61bf5a8f.svg";